import { MemoEdit } from '@powerportalspro/react-fluent';

export function MemoEditMainSample() {
  return <MemoEdit columnName="ppp_description" style={{ minWidth: 300 }} />;
}
